import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    getAllUserRoles: [],
    loading: false,
    error: null,
}

const getAllUserRolesSlice = createSlice({
    name: "getAllUserRoles",
    initialState,
    reducers: {
        fetchGetAllUserRolesSuccess: (state, action) => {
            state.loading = false;
            state.getAllUserRoles = action.payload;
        },
        fetchGetAllUserRolesFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const { fetchGetAllUserRolesSuccess,fetchGetAllUserRolesFailure } = getAllUserRolesSlice.actions;

export default getAllUserRolesSlice.reducer;
